import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import { FeatureLabel3D } from '../procedural/FeatureLabel3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from '../procedural/SurfaceMeshFeature3D'
import { useSurfaceProps } from '@asset-viz/objects/surfaces/util/SurfaceProvider'
import React from 'react'
import {
  GeckoComponentCoords,
  GeckoComponentPolygon,
  GeckoPipeWrap,
} from 'types'

/**
 * A component representing the non-integral support on the surface of a pipe
 * section component
 * @param model             The non-integral pipe support model (from the asset model)
 * @param pipeRadius        The radius of the pipe this support is on
 * @constructor
 */
export const PipeWrapFeature3D: React.FC<{
  model: GeckoPipeWrap
}> = ({ model }) => {
  //----------------------------------------------------------------------------

  const { bounds } = useSurfaceProps()
  const { show3D } = useAssetVizInternal()

  const { centerX, centerY } = React.useMemo(() => {
    const centerX = model.geometry.x.start.plus(model.geometry.x.end).scale(0.5)
    const centerY = model.geometry.y.start.plus(model.geometry.y.end).scale(0.5)
    return { centerX, centerY }
  }, [model.geometry])

  const path = React.useMemo(() => {
    return GeckoComponentPolygon.CreateFromRect(model.geometry)
  }, [model.geometry])

  const centerCoords = React.useMemo(
    () =>
      GeckoComponentCoords.CreateFromMeasurements(
        bounds.componentID,
        centerX,
        centerY
      ),
    [bounds, centerX, centerY]
  )

  //----------------------------------------------------------------------------

  return (
    <>
      <FeatureLabel3D
        feature={model}
        coords={centerCoords}
        anchor={'center'}
        scale={show3D ? [1.1, 1, 1.1] : [1, 1, 1]}
      />
      <SurfaceMeshFeature3D
        path={path}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        colorMesh
        scale={show3D ? [1.1, 1, 1.1] : [1, 1, 1]}
      />
    </>
  )
}
